import * as React from 'react';
const SvgSuccess = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 12 9" fill="none" {...props}>
        <path
            d="M4.616 6.391l-3.06-3.305a.9.9 0 00-1.473.23.89.89 0 00.154.98L4.592 9l7.161-7.493A.89.89 0 0011.083 0a.899.899 0 00-.629.277L4.616 6.391z"
            fill="currentColor"
        />
    </svg>
);
export default SvgSuccess;
